import { Reducer } from 'redux';

import * as Types from './types';

const { ActionTypes } = Types;

const defaultState: Types.CampaignsState = {
    loading: false,
};

const reducer: Reducer<Types.CampaignsState> = (
    state: Types.CampaignsState = defaultState,
    action
): Types.CampaignsState => {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.GET_CAMPAIGNS:
            return { ...state, loading: true };
        case ActionTypes.UPDATE_CAMPAIGNS_STORE:
            return { ...state, campaignsList: payload.campaignsList, loading: false };
        case ActionTypes.CAMPAIGNS_ERROR:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export { reducer as apiCampaigns };
